import { FormHelperText, Stack } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SunEditor from 'suneditor-react';

const containsScriptsOrIframes = (content) =>
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi.test(content) || // Detect <script>
    /<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi.test(content) || // Detect <iframe>
    /\bon\w+=["'].*?["']/gi.test(content);

const handleEditorContainerClick = (e) => {
    if (e.target.tagName === 'BUTTON') {
        e.preventDefault();
        e.stopPropagation();
    }
};

const CustomSunEditor = (props) => {
    const { onChange, sunError, ...rest } = props;
    const { t } = useTranslation();

    const [error, setError] = useState(false);

    const editorRef = useRef(null);

    const cleanValue = useCallback((value) => {
        if (containsScriptsOrIframes(value)) {
            setError(true);
            sunError(true);
            return;
        }
        setError(false);
        sunError(false);
        onChange(value);
    }, [onChange, sunError]);

    useEffect(() => {
        const editor = editorRef.current;
        
        if (!editor) return;

        const codeBtn = editor.core.context.element.toolbar.querySelector(
            "[data-command='codeView']"
        );

        if (!codeBtn) return;

        codeBtn.addEventListener("click", () => {
            setTimeout(() => {
                if (!editor.core.context.element) return;
                if (!editor.core.context.element.editorArea) return;
                
                const editorArea = editor.core.context.element.editorArea;
                const isCodeView = editorArea.querySelector("textarea").style.display !== "none";
                if (isCodeView) {
                    const textarea = editorArea.querySelector("textarea");
                    if (textarea) {
                        textarea.addEventListener("input", () => {
                            cleanValue(textarea.value);
                        });
                    }
                }
            }, 100); // Allow time for the editor to switch modes
        });
    }, [cleanValue]);

    return (
        <Stack>
            <div onClick={handleEditorContainerClick}>
                <SunEditor
                    {...rest}
                    getSunEditorInstance={(editor) => {
                        editorRef.current = editor;
                    }}
                    onChange={cleanValue}
                />
            </div>
            {error ? <FormHelperText error>{t('app.common.sunEditorError')}</FormHelperText> : null}
        </Stack>
    );
};

export default CustomSunEditor;
